module.exports = __webpack_public_path__ + "assets/img/G3.2950e6fd.png";